import { jsx, jsxs } from 'react/jsx-runtime';
import { useRef, useCallback } from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import classNames from 'classnames';

const ScrollArea = ({ className, children, autoHide = false, overflowMask = true, onScroll, onUpdate, ...rest })=>{
    const containerRef = useRef(null);
    const contentRef = useRef(null);
    /**
     * Handle container content scroll.
     */ const handleOnScroll = useCallback((e)=>{
        const container = containerRef.current;
        const content = contentRef.current;
        if (!container || !content) return;
        const atTop = e.currentTarget.scrollTop <= 0;
        const atBottom = content.scrollHeight - (e.currentTarget.scrollTop + container.offsetHeight + 15) <= 0; // 15px to account for the margin
        /** Trigger user provided callback. */ onScroll?.({
            atBottom,
            atTop
        });
        /**
         * When at the top of the container we only want to show the mask at
         * the bottom.
         *
         * After scrolling, we want both a top and bottom mask.
         */ container.classList.toggle('bottom-mask', atTop);
        container.classList.toggle('top-and-bottom-mask', !atTop && !atBottom);
        container.classList.toggle('top-mask', atBottom);
    }, [
        onScroll
    ]);
    const renderTrackVertical = useCallback((props)=>jsx("div", {
            ...props,
            className: "track-vertical",
            "data-testid": "track-vertical"
        }), []);
    const renderThumbVertical = useCallback((props)=>jsx("div", {
            ...props,
            className: "thumb-vertical"
        }), []);
    const handleOnUpdate = useCallback((scrollValues)=>{
        onUpdate?.(scrollValues);
    }, [
        onUpdate
    ]);
    return jsx("div", {
        ref: containerRef,
        className: classNames('cb-scroll-container', {
            'with-overflow-mask bottom-mask': overflowMask
        }, className),
        "data-testid": "scroll-container",
        children: jsx(Scrollbars, {
            autoHide: autoHide,
            onScroll: overflowMask ? handleOnScroll : undefined,
            onUpdate: handleOnUpdate,
            renderThumbVertical: renderThumbVertical,
            renderTrackVertical: renderTrackVertical,
            hideTracksWhenNotNeeded: true,
            universal: true,
            children: jsxs("div", {
                ref: contentRef,
                className: "content",
                "data-testid": "scroll-content",
                ...rest,
                children: [
                    children,
                    jsx("div", {
                        className: "scroll-end"
                    })
                ]
            })
        })
    });
};
ScrollArea.displayName = 'ScrollArea';

export { ScrollArea, ScrollArea as default };
//# sourceMappingURL=ScrollArea.es.js.map
